import { parseFullName as parse } from "parse-full-name";

interface ParsedName {
    firstName: string;
    middleName?: string;
    lastName: string;
}

export function parseFullName(fullName: string): ParsedName {
    if (!fullName || fullName.trim() === "") {
        return { firstName: "-", lastName: "-" };
    }

    const parsed = parse(fullName, "all");

    const firstName = parsed.first ?? "-";
    const lastName = parsed.last ?? (parsed.first ? "-" : "-");

    const middleName = parsed.middle || undefined;

    if (firstName !== "-" && lastName === "-") {
        return { firstName, lastName: "-" };
    }

    if (firstName === "-" && lastName === "-") {
        const fallback = fullName.trim().split(/\s+/)[0];
        return { firstName: fallback || "-", lastName: "-" };
    }

    return {
        firstName,
        middleName,
        lastName,
    };
}
